export default function includes(array, item) {
  return array.includes(item);
}
